<template>
  <el-card class="box-card full-screen">
    <div ref="pageHead" class="table-page-head">
      <el-form :inline="true" :model="queryForm">
        <el-form-item
          v-if="loginInfo.orgType == 1"
          :label="$t('affiliationOrg')"
        >
          <el-select
            v-model="queryForm.orgInfoId"
            :placeholder="$t('all')"
            filterable
            size="small"
          >
            <el-option :label="$t('all')" value=""></el-option>
            <el-option
              v-for="(t, i) in orgList"
              :key="i"
              :label="t.name + ' -- ' + t.orgInfoCode"
              :value="t.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('status')">
          <el-select
            v-model="queryForm.status"
            :placeholder="$t('all')"
            size="small"
            clearable
          >
            <el-option :label="$t('all')" value=""></el-option>
            <el-option :label="$t('await')" :value="0"></el-option>
            <el-option :label="$t('trading')" :value="1"></el-option>
            <el-option
              :label="$t('completeTransaction')"
              :value="2"
            ></el-option>
            <el-option :label="$t('failureTransaction')" :value="3"></el-option>
            <el-option :label="$t('reversaling')" :value="4"></el-option>
            <el-option :label="$t('completeReversal')" :value="5"></el-option>
            <el-option :label="$t('failureReversal')" :value="6"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item :label="$t('linkPhone')">
          <el-input v-model="queryForm.phone" size="small"></el-input>
        </el-form-item>
        <el-form-item :label="$t('idNumber')">
          <el-input v-model="queryForm.idCard" size="small"></el-input>
        </el-form-item>
        <el-form-item :label="$t('date')">
          <el-date-picker
            v-model="queryForm.date"
            type="daterange"
            range-separator="~"
            :start-placeholder="$t('startDate')"
            :end-placeholder="$t('endDate')"
            value-format="yyyy-MM-dd"
            size="small"
            unlink-panels
            :clearable="true"
            @change="changeDate"
          ></el-date-picker>
        </el-form-item>
        <el-form-item>
          <el-button
            type="primary"
            size="small"
            @click="getList"
            :loading="isloading"
            ><i class="el-icon-search"></i> {{ $t("query") }}</el-button
          >
        </el-form-item>
      </el-form>
    </div>

    <div
      class="data-table"
      :style="{
        top: queryTableHeight,
        height: `calc(100% - ${queryTableHeight} - 70px)`,
      }"
    >
      <el-table
        :data="tableData.records"
        v-loading="isloading"
        element-loading-background="rgba(255,255,255,0.4)"
        size="mini"
        height="100%"
      >
        <el-table-column
          prop="transactionCode"
          :label="$t('transactionCode')"
          min-width="210"
        ></el-table-column>

        <!-- Customer (account being deposited to) -->
        <el-table-column
          align="center"
          :label="$t('customerInfo')"
          class-name="multiple-header-intervals"
        >
          <el-table-column :label="$t('compellation')" min-width="160">
            <template slot-scope="scope">{{ scope.row.customerName }}</template>
          </el-table-column>
          <el-table-column
            prop="phone"
            :label="$t('phone')"
            min-width="180"
          ></el-table-column>
        </el-table-column>

        <!-- Depositor info (from depositor_* columns) -->
        <el-table-column
          align="center"
          :label="$t('depositorInfo')"
          class-name="multiple-header-intervals"
        >
          <el-table-column :label="$t('compellation')" min-width="160">
            <template slot-scope="scope">
              {{ scope.row.depositorFirstName }}
              {{ scope.row.depositorLastName }}
            </template>
          </el-table-column>
          <el-table-column
            prop="depositorPhoneNo"
            :label="$t('linkPhone')"
            min-width="140"
          ></el-table-column>
        </el-table-column>

        <!-- Deposit info -->
        <el-table-column
          align="center"
          :label="$t('depositInfo')"
          class-name="multiple-header-intervals"
        >
          <el-table-column prop="amount" :label="$t('amount')" min-width="140">
            <template slot-scope="scope">
              <span class="franc">₣</span
              >{{
                String(scope.row.amount)
                  .replace("-", "")
                  .split(".")[0]
                  .formatMoney(0)
              }}
            </template>
          </el-table-column>
          <el-table-column
            prop="serviceChargeAmount"
            :label="$t('serviceCharge')"
            min-width="140"
          >
            <template slot-scope="scope">
              <span class="franc">₣</span
              >{{
                scope.row.serviceChargeAmount
                  ? String(scope.row.serviceChargeAmount)
                      .split(".")[0]
                      .formatMoney(0)
                  : "0"
              }}
            </template>
          </el-table-column>
          <el-table-column prop="status" :label="$t('status')" min-width="150">
            <template slot-scope="scope">
              <el-tag v-if="scope.row.status == 0" type="info">{{
                $t("await")
              }}</el-tag>
              <el-tag v-else-if="scope.row.status == 1" type="warning">{{
                $t("trading")
              }}</el-tag>
              <el-tag v-else-if="scope.row.status == 2" type="success">{{
                $t("completeTransaction")
              }}</el-tag>
              <el-tag v-else-if="scope.row.status == 3" type="danger">{{
                $t("failureTransaction")
              }}</el-tag>
              <el-tag v-else-if="scope.row.status == 4" type="warning">{{
                $t("reversaling")
              }}</el-tag>
              <el-tag v-else-if="scope.row.status == 5" type="primary">{{
                $t("completeReversal")
              }}</el-tag>
              <el-tag v-else-if="scope.row.status == 6" type="danger">{{
                $t("failureReversal")
              }}</el-tag>
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            :label="$t('creationTime')"
            min-width="160"
          >
            <template slot-scope="scope">{{
              scope.row.createTime
                ? $manba(scope.row.createTime).format("ymdhms")
                : ""
            }}</template>
          </el-table-column>
          <el-table-column
            prop="doneTime"
            :label="$t('doneTime')"
            min-width="160"
            class-name="multiple-header-intervals"
          >
            <template slot-scope="scope">{{
              scope.row.doneTime
                ? $manba(scope.row.doneTime).format("ymdhms")
                : ""
            }}</template>
          </el-table-column>
        </el-table-column>

        <!-- Operation info -->
        <el-table-column align="center" :label="$t('operateInfo')">
          <el-table-column
            prop="orgName"
            :label="$t('operateOrg')"
            min-width="160"
          ></el-table-column>
          <el-table-column :label="$t('tradeAssistant')" min-width="160">
            <template slot-scope="scope"
              >{{ scope.row.createSurname }}
              {{ scope.row.createName }}</template
            >
          </el-table-column>
          <el-table-column
            prop="transactionRemark"
            :label="$t('remark')"
            min-width="160"
          ></el-table-column>
        </el-table-column>
      </el-table>
    </div>

    <el-pagination
      background
      layout="total,sizes,prev,pager,next,jumper"
      :total="tableData.total"
      :page-sizes="[20, 30, 50, 100, 200]"
      :page-size="pageSize"
      :current-page="currentPage"
      @size-change="setPageSzie"
      @current-change="setCurrentChange"
      @prev-click="setCurrentChange"
      @next-click="setCurrentChange"
    />
  </el-card>
</template>

<script>
import org from "@/api/org";
import transactionInfo from "@/api/transactionInfo";
export default {
  name: "depositList",
  data() {
    return {
      queryForm: {},
      queryTableHeight: String,
      orgList: [],
      tableData: {},
      pageSize: 20,
      currentPage: 1,
      isloading: false,
    };
  },
  computed: {
    loginInfo() {
      return this.$store.state.globalParameter.loginInfo;
    },
    countryList() {
      return this.$store.state.globalParameter.countryList;
    },
  },
  methods: {
    getList() {
      let _this = this;
      let params = JSON.parse(JSON.stringify(_this.queryForm));
      if (params.date && params.date.length > 0) {
        params.startDate = _this.$manba(params.date[0]).format("ymd");
        params.endDate = _this.$manba(params.date[1]).format("ymd");
      } else {
        params.startDate = undefined;
        params.endDate = undefined;
      }
      delete params.date;
      if (!params.phone) delete params.phone;
      if (!params.idCard) delete params.idCard;
      if (!params.orgInfoId) delete params.orgInfoId;
      if (
        params.status === "" ||
        params.status === null ||
        params.status === undefined
      )
        delete params.status;

      _this.isloading = true;
      transactionInfo.getPage({
        param: {
          current: _this.currentPage,
          size: _this.pageSize,
          businessCode: 40,
          ...params,
        },
        success: (res) => {
          _this.isloading = false;
          _this.tableData = res.data || {};
        },
      });
    },
    getOrgList() {
      let _this = this;
      org.getOrgInfoPage({
        param: { current: 1, size: 10000 },
        success: (res) => {
          if (res.data) _this.orgList = res.data.records;
        },
      });
    },
    setPageSzie(val) {
      this.pageSize = val;
      this.getList();
    },
    setCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    changeDate(e) {
      if (e === null) {
        this.queryForm.date = null;
      }
    },
  },
  mounted() {
    let queryTableHeight = this.$refs.pageHead.offsetHeight + 15;
    this.queryTableHeight = queryTableHeight + "px";
    this.getList();
    this.getOrgList();
  },
};
</script>

<style lang="less"></style>
